<template>
  <div class="vx-card">
    <div v-if="showLoading">
      <div id="loading-grid" class="py-10">
        <svg class="spinner" width="65px" height="65px" viewBox="0 0 66 66">
          <circle
            class="path"
            fill="none"
            stroke-width="6"
            stroke-linecap="round"
            cx="33"
            cy="33"
            r="30"
          ></circle>
        </svg>
      </div>
    </div>
    <div class="vx-card__body" v-else>
      <form>
        <div class="vx-row hide-in-print">
          <div class="vx-col lg:w-1/4 sm:w-1/3 w-full">
            <vs-input
              class="inputx"
              v-model="
                dischargePermission.dischargePermissionOperatorQuery
                  .operatorName
              "
              :label="$t('Creator')"
              readonly="readonly"
            />
          </div>
          <div class="vx-col lg:w-1/4 sm:w-1/3 w-full">
            <vs-input
              class="inputx"
              v-model="dischargePermission.draftOrderId"
              :label="$t('DraftOrderId')"
              readonly="readonly"
            />
          </div>
          <div class="vx-col lg:w-1/4 sm:w-1/3 w-full">
            <vs-input
              class="inputx"
              v-model="
                dischargePermission.dischargePermissionPartyInfoQuery.partyName
              "
              :label="$t('Applicant')"
              readonly="readonly"
            />
          </div>
          <div class="vx-col lg:w-1/4 sm:w-1/3 w-full">
            <vs-input
              class="inputx"
              v-model="
                dischargePermission.dischargePermissionPartyInfoQuery.partyId
              "
              :label="$t('ApplicantId')"
              readonly="readonly"
            />
          </div>
        </div>
        <div class="vx-row my-3 hide-in-print">
          <div class="vx-col sm:w-1/4 w-full mt-1">
            <vs-input
              class="inputx"
              v-model="modelForApi.registerClock"
              :label="$t('CreationDate')"
              readonly="readonly"
            />
          </div>
          <div class="vx-col sm:w-1/4 w-full mt-1">
            <vs-input
              class="inputx"
              v-model="dischargePermission.id"
              :label="$t('DischargePermissionId')"
              readonly="readonly"
            />
          </div>
          <div class="vx-col sm:w-1/2 w-full">
            <label class="vs-select--label">{{ $t("Description") }}</label>
            <vs-textarea v-model="modelForApi.description" rows="1" />
          </div>
        </div>
        <div class="vx-row hide-in-print">
          <div class="vx-col w-9/12 mb-2">
            <vs-button
              :color="isProcess ? 'warning' : 'primary'"
              icon-pack="feather"
              class="bg_green"
              type="filled"
              @click.prevent="isShowAddSerialWithBarcodeReader()"
              >{{ $t("AddSerialWithBarcodeReader") }}</vs-button
            >
            <vs-button
              :color="isProcess ? 'warning' : 'primary'"
              icon-pack="feather"
              class="bg_green mx-4"
              type="filled"
              @click.prevent="isShowAddSerialWithBarcodeReaderAccumulative()"
              >{{ $t("AddSerialWithBarcodeReaderAccumulative") }}</vs-button
            >
            <vs-button
              color="primary"
              icon-pack="feather"
              class="bg_green"
              type="filled"
              @click.prevent="PrintTable()"
              >{{ $t("PrintTableUnder") }}</vs-button
            >
          </div>
          <div class="vx-col w-3/12 mb-2">
            <vs-button
              @click.prevent="uploadFile()"
              class="bg_m_green float-right"
              v-if="fileUploaded"
              :disabled="disabledBtn"
              v-has-permission="permission220"
            >
              <feather-icon icon="PlusIcon" svgClasses="h-4 w-4" class="ico" />
              {{ $t("UploadFile") }}
            </vs-button>
            <label class="custom-file-upload">
              <input
                type="file"
                id="file"
                ref="file"
                v-on:change="handleFileUpload()"
              />
              <feather-icon
                icon="PaperclipIcon"
                svgClasses="h-4 w-4"
                class="ico"
              />
              {{ $t("ChooseFile") }}
              <span v-if="uploadedFileName" class="file-name">{{
                uploadedFileName
              }}</span>
            </label>
          </div>
        </div>
        <vs-table :data="modelForShow" class="custom-tbl addPadding">
          <template slot="thead">
            <th style="width: 2%">#</th>
            <th style="width: 20%">{{ $t("Product") }}</th>
            <th style="width: 10%">{{ $t("ItemCode") }}</th>
            <th style="width: 7%">{{ $t("CountOfOperatorRequested") }}</th>
            <th style="width: 7%">{{ $t("CountOfCheckout") }}</th>
            <th style="width: 7%">{{ $t("Count") }}</th>
            <th style="width: 10%">{{ $t("Warehouse") }}</th>
            <th style="width: 10%">{{ $t("Shelve") }}</th>
            <th style="width: 27%">{{ $t("Action") }}</th>
          </template>
          <template slot-scope="{ data }">
            <vs-tr :key="i" v-for="(tr, i) in data">
              <vs-td
                :data="tr"
                :class="
                  tr.remainingCountForCheckout == tr.serialsInfo.length ||
                  tr.countOfOperatorRequested == tr.countOfCheckout
                    ? 'bg-success'
                    : ''
                "
              >
                {{ parseInt(i) + 1 }}
              </vs-td>
              <vs-td :data="tr.productName">
                {{ tr.productName }}
              </vs-td>
              <vs-td :data="tr.itemCode">
                {{ tr.itemCode }}
              </vs-td>
              <vs-td :data="tr.countOfOperatorRequested">
                {{ tr.countOfOperatorRequested }}
              </vs-td>
              <vs-td :data="tr.countOfCheckout">
                {{ tr.countOfCheckout }}
              </vs-td>
              <vs-td :data="tr.remainingCountForCheckout">
                {{ tr.remainingCountForCheckout }}
              </vs-td>
              <vs-td :data="tr.storeName">
                {{ tr.storeName }}
              </vs-td>
              <vs-td :data="tr.shelveName">
                {{ tr.shelveName }}
              </vs-td>
              <vs-td class="hide-in-print">
                <span v-if="tr.productType == 'Serial'">
                  <vs-button
                    color="primary"
                    type="border"
                    icon-pack="feather"
                    class="serial-btn mx-0"
                    @click.prevent="addSerial(tr.itemCode)"
                    >{{ $t("SerialNumbers") }}</vs-button
                  >
                </span>
                <span v-if="tr.productType == 'Measurable'" class="dash-item"
                  >-</span
                >
                <span>
                  <router-link
                    :to="{
                      path: '/DischargeCheckOut/PrintLabel2',
                      query: {
                        sortSerialsDto: tr.serialsInfo,
                        productId: tr.productId,
                        stockId: tr.productId,
                        itemCode: tr.itemCode,
                        basketId: dischargePermission.basketId,
                        transactionId: dischargePermission.id,
                        storeId: dischargePermission.storeId,
                        isProcess: dischargePermission.isProcess,
                        id: dischargePermission.id,
                      },
                    }"
                  >
                    <vs-button
                      color="primary"
                      type="border"
                      class="view-btn mx-2"
                      :disabled="tr.serialsInfo.length == 0"
                    >
                      {{ $t("PrintLabel") }}
                    </vs-button>
                  </router-link>
                </span>
                <span>
                  <router-link
                    :to="{
                      path: '/CheckOutForDraftOrder/PrintWarrantyCard2',
                      query: {
                        sortSerialsDto: tr.serialsInfo,
                        productId: tr.productId,
                        stockId: tr.productId,
                        itemCode: tr.itemCode,
                        basketId: dischargePermission.basketId,
                        transactionId: dischargePermission.id,
                        storeId: dischargePermission.storeId,
                        isProcess: dischargePermission.isProcess,
                        id: dischargePermission.id,
                      },
                    }"
                  >
                    <vs-button
                      color="primary"
                      type="border"
                      class="view-btn mx-0"
                      :disabled="tr.serialsInfo.length == 0"
                    >
                      {{ $t("PrintWarrantyCard") }}
                    </vs-button>
                  </router-link>
                </span>
              </vs-td>
            </vs-tr>
          </template>
        </vs-table>
      </form>
      <discharge-check-out-serial-popup
        :show="showSerialPopup"
        :modelForShowCurrent="modelForShowCurrent"
        :modelForInternalApi="modelForInternalApi"
        :lastIndexRegistered="lastIndexRegistered"
        @finish="onfinish"
      ></discharge-check-out-serial-popup>
      <add-serial-with-barcode-reader-popup
        :show="onShowAddSerialWithBarcodeReaderPopup"
        :modelForLocalStorage="modelForLocalStorage"
        :dischargePermissionId="dischargePermissionId"
        :basketId="basketId"
        :storeId="storeId"
        @finish="onfinish"
      ></add-serial-with-barcode-reader-popup>
      <!-- <add-serial-with-barcode-reader-popup
        :show="onShowAddSerialWithBarcodeReaderPopup"
        :modelForShow="modelForShow"
        :dischargePermissionId="dischargePermissionId"
        :lastIndexRegistered="lastIndexRegistered"
        @finish="onfinish"
      ></add-serial-with-barcode-reader-popup> -->
      <add-serial-with-barcode-reader-accumulative-popup
        :show="onShowAddSerialWithBarcodeReaderAccumulativePopup"
        :modelForShow="modelForShow"
        :basketId="basketId"
        :storeId="storeId"
        :dischargePermissionId="dischargePermissionId"
        :lastIndexRegistered="lastIndexRegistered"
        @finish="onfinish"
      ></add-serial-with-barcode-reader-accumulative-popup>
      <div class="vx-row mt-6 hide-in-print">
        <div class="vx-col w-full">
          <vs-button
            type="filled"
            class="float-right"
            @click.prevent="submitForm"
            :disabled="disabled"
            >{{ $t("CreateCheckout") }}</vs-button
          >
        </div>
      </div>
    </div>
  </div>
</template>
<style lang="scss" scoped>
::v-deep .vs-select--label {
  margin-top: 6px;
  margin-bottom: 2px;
  display: block;
}

::v-deep.text-danger {
  position: relative;
  top: -10px !important;
}

::v-deep .dash-item {
  width: 9rem;
  display: inline-table;
}
::v-deep .showhide {
  opacity: 0.5;
  z-index: 1;
}
::v-deep input[type="file"] {
  display: none;
}

::v-deep .custom-file-upload {
  border: 1px solid #ccc;
  display: inline-block;
  padding: 4px 12px 4px 12px;
  cursor: pointer;
  float: left;
}

::v-deep .bg_m_green {
  border-radius: 6px 0 0 6px !important;
  padding: 0.3rem 0.8rem !important;
}

::v-deep .file-name {
  padding: 0 0.5rem;
  background-color: #eeeff1;
  position: relative;
  left: -0.65rem;
}

::v-deep #reset-btn {
  margin-left: 1.5rem;
  background: #3ec9d6 !important;
}
</style>
<script>
import "@/assets/scss/vuesax-rtl/pages/_custom.scss";
import "@riophae/vue-treeselect/dist/vue-treeselect.css";
import { mapActions } from "vuex";
import "../../../assets/scss/vuesax-rtl/pages/_warehouse.scss";
import VuePersianDatetimePicker from "vue-persian-datetime-picker";
import DischargeCheckOutSerialPopup from "./DischargeCheckOutSerialPopup.vue";
import * as moment from "jalali-moment";
import Swal from "sweetalert2/dist/sweetalert2.js";
import AddSerialWithBarcodeReaderPopup from "./AddSerialWithBarcodeReaderPopup.vue";
import AddSerialWithBarcodeReaderAccumulativePopup from "./AddSerialWithBarcodeReaderAccumulativePopup.vue";

export default {
  name: "warehouseManagement_CheckOutTransactions_DischargeCheckout",
  components: {
    datePicker: VuePersianDatetimePicker,
    DischargeCheckOutSerialPopup,
    AddSerialWithBarcodeReaderPopup,
    AddSerialWithBarcodeReaderAccumulativePopup,
  },
  data() {
    return {
      permission220: "RegisterCheckOutForDraftOrderWithExcelFile",
      showLoading: true,
      lastIndexRegistered: 0,
      modelForTime: { dischargePermissionId: "" },
      isProcess: false,
      disabled: false,
      // needToUpdate: false,
      showSerialPopup: false,
      onShowAddSerialWithBarcodeReaderPopup: false,
      onShowAddSerialWithBarcodeReaderAccumulativePopup: false,
      modelForApi: {
        storeId: null,
        requesterInfoCommand: { requesterId: "1", requesterName: "Admin" },
        draftOrderInfoCommand: {
          draftOrderId: null,
          dischargePermissionId: null,
        },
        registerClock: null,
        automationCode: null,
        description: null,
        checkType: 0,
        inventoryTransactionItemCommands: [],
      },
      inventoryTransactionItemCommandsFinal: [],
      modelForShow: [],
      isAddNewItemCode: false,
      oldDataFromLocalStorage: [],
      modelForLocalStorageReturn: [],
      oldDateBeforetwobutton: [],
      modelForLocalStorage: [],
      // oldModelForLocalStorage: [],
      listRowIndesxNotComplate: [],
      newModelForUpdateLocalStorage: [],
      // modelForLocalStorage1: [],
      dischargePermission: {},
      modelForShowCurrent: {},
      modelForInternalApi: {},
      finalModelLocalStorage: {},
      itemCode: "",
      file: "",
      aaa: {},
      AllRowsItems: {},
      tinyModelForShow: {},
      tinyModelForApi: {},
      fileUploaded: false,
      disabledBtn: false,
      isemptyRequest: true,
      uploadedFileName: "",
      wrongTextForMessage: "",
      itemCodeCurrent: "",
    };
  },

  mounted() {
    this.load();
    this.listenToDischargeEvents();
  },
  methods: {
    ...mapActions({
      setStartTimeOfCheckout: "dischargePermissions/setStartTimeOfCheckout",
      createCheckOut: "checkOutTransactions/createDischargeCheckOut",
      fetchPermissionBasedOnstore:
        "dischargePermissions/partialDischargePermissionBasedOnStore",
      startProcessOfDischargePermissionForCheckout:
        "dischargePermissions/startProcessOfDischargePermissionForCheckout",
      fetchSingle: "dischargePermissions/partialDischargePermissions",
      importCheckOutTransactions: "excel/importCheckOutTransactions",
    }),
    listenToDischargeEvents() {
      window.addEventListener("notification-event", (event) => {
        Swal.fire({
          position: "center-center",
          type: "error",
          text: event.detail.message,
          showConfirmButton: false,
          showCloseButton: true,
        });
      });
    },
    calcCurrentTime() {
      let todayJalali = moment().locale("fa").format("YYYY-M-D hh:mm:ss");
      this.modelForApi.registerClock = todayJalali;
    },
    getDataFromLocalStorage() {
      this.modelForLocalStorage = [];
      this.modelForLocalStorage = localStorage.getItem(
        "basket" + this.basketId + "store" + this.storeId
      );
      if (this.modelForLocalStorage) {
        this.modelForLocalStorage = JSON.parse(this.modelForLocalStorage);
        this.conversionDataFromLocalStorageToModelForShow();
      } else {
        this.createEmptyModelForLocalStorage();
        localStorage.setItem(
          "basket" + this.basketId + "store" + this.storeId,
          JSON.stringify(this.modelForLocalStorage)
        );
      }
    },
    createEmptyModelForLocalStorage() {
      this.modelForLocalStorage = this.modelForShow.map((elem) => {
        return {
          itemCode: elem.itemCode,
          remainingCountForCheckout: elem.remainingCountForCheckout,
          serialsInfo: elem.serialsInfo,
        };
      });
    },
    conversionDataFromLocalStorageToModelForShow() {
      this.modelForLocalStorage.forEach((elem) => {
        for (let index = 0; index < this.modelForShow.length; index++) {
          if (this.modelForShow[index].itemCode == elem.itemCode) {
            this.modelForShow[index].serialsInfo = [];
            for (let qq = 0; qq < elem.serialsInfo.length; qq++) {
              var data = {
                serial: elem.serialsInfo[qq].serial,
                index: elem.serialsInfo[qq].index,
              };
              this.modelForShow[index].serialsInfo.push(data);
              data = {};
            }
          }
        }
      });
    },
    createModels() {
      this.modelForApi = {
        storeId: this.storeId,
        registerClock: null,
        automationCode: null,
        description: null,
        checkType: 0,
        inventoryTransactionItemCommands: [],
        requesterInfoCommand: {
          requesterId:
            this.dischargePermission.dischargePermissionPartyInfoQuery.partyId.toString(),
          requesterName:
            this.dischargePermission.dischargePermissionPartyInfoQuery
              .partyName,
        },
        draftOrderInfoCommand: {
          draftOrderId: this.dischargePermission.draftOrderId,
          dischargePermissionId: this.dischargePermission.id,
        },
      };
      for (let index = 0; index < this.AllRowsItems.length; index++) {
        var productInfoEvent =
          this.AllRowsItems[index].dischargePermissionProductInfoEvent;
        var shelveInfoQuery =
          this.AllRowsItems[index].partialDischargePermissionShelveInfoQuery;
        this.createModelForShow(productInfoEvent, shelveInfoQuery);
        this.createModelEmptyForApi(productInfoEvent, shelveInfoQuery);
      }
    },
    async load() {
      this.dischargePermissionId = this.$route.params.id;
      this.modelForTime.dischargePermissionId = this.$route.params.id;
      this.isProcess = this.$route.query.isProcess;
      this.storeId = this.$route.query.storeId;
      this.setStartTimeOfCheckout(this.modelForTime).then(() => {});
      this.checkIsProcessing();
      await this.fetchPermissionBasedOnstore({
        id: this.dischargePermissionId,
        storeId: this.storeId,
      })
        .then((r) => {
          this.dischargePermission = r;
          this.basketId = this.dischargePermission.basketId;
          this.AllRowsItems =
            this.dischargePermission.partialDischargePermissionItemsQueryDto;
          this.createModels();
          this.getDataFromLocalStorage();
          this.calcCurrentTime();
        })
        .finally(() => {
          this.showLoading = false;
        });
    },
    createModelEmptyForApi(productInfoEvent, shelveInfoQuery) {
      this.tinyModelForApi = {
        stockId: productInfoEvent.productId,
        name: productInfoEvent.productName,
        shelveId: shelveInfoQuery.shelveId,
        shelveName: shelveInfoQuery.shelveName,
        serialsInfo: [],
        count: 0,
        destinationShelveId: null,
        destinationShelveName: null,
      };
      this.modelForApi.inventoryTransactionItemCommands.push(
        this.tinyModelForApi
      );
      this.tinyModelForApi = {};
    },
    createModelForShow(productInfoEvent, shelveInfoQuery) {
      this.tinyModelForShow = {
        productName: productInfoEvent.productName,
        itemCode: productInfoEvent.itemCode,
        countOfOperatorRequested: shelveInfoQuery.countOfOperatorRequested,
        countOfCheckout: shelveInfoQuery.countOfCheckout,
        remainingCountForCheckout: shelveInfoQuery.remainingCountForCheckout,
        storeName: shelveInfoQuery.storeName,
        shelveName: shelveInfoQuery.shelveName,
        serialsInfo: [],
        countOfRegistered: 0,
        productId: productInfoEvent.productId,
        productType: productInfoEvent.productType,
        storeId: shelveInfoQuery.storeId,
        shelveId: shelveInfoQuery.shelveId,
        stockId: productInfoEvent.productId,
      };
      if (this.tinyModelForShow.serialsInfo.length) {
        this.tinyModelForShow.countOfRegistered =
          this.tinyModelForShow.serialsInfo.length;
      }
      this.modelForShow.push(this.tinyModelForShow);
      this.tinyModelForShow = {};
    },
    PrintTable() {
      window.print();
    },
    isShowAddSerialWithBarcodeReader() {
      if (this.isProcess) {
        this.if_isProcess_IsTrue("notAccumulative");
      } else {
        this.RecordWorkTimWwithBarcodeReader("notAccumulative");
      }
    },
    isShowAddSerialWithBarcodeReaderAccumulative() {
      if (this.isProcess) {
        this.if_isProcess_IsTrue("Accumulative");
      } else {
        this.RecordWorkTimWwithBarcodeReader("Accumulative");
      }
    },
    RecordWorkTimWwithBarcodeReader(type) {
      this.startProcessOfDischargePermissionForCheckout(
        this.modelForTime.dischargePermissionId
      ).then(() => {
        this.findMaxIndex();
        if (type == "Accumulative")
          this.onShowAddSerialWithBarcodeReaderAccumulativePopup = true;
        else this.onShowAddSerialWithBarcodeReaderPopup = true;
      });
    },
    if_isProcess_IsTrue(type) {
      this.$swal({
        title:
          "این حواله توسط اپراتور دیگری در حال پردازش است.آیا قصد پردازش مجدد دارید؟",
        type: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "بلی",
        cancelButtonText: "خیر",
      }).then((result) => {
        if (result.value) {
          this.findMaxIndex();
          if (type == "Accumulative")
            this.onShowAddSerialWithBarcodeReaderAccumulativePopup = true;
          else this.onShowAddSerialWithBarcodeReaderPopup = true;
        }
      });
    },
    changeCount(index, event) {
      var count = event.target.value;
      let dataForEachRow =
        this.dischargePermission.partialDischargePermissionItemsQueryDto[index]
          .partialDischargePermissionShelveInfoQuery;
      if (
        dataForEachRow.countOfOperatorRequested ==
        dataForEachRow.countOfCheckout
      ) {
        event.target.value = 0;
        count = 0;
      } else {
        if (
          count >
          dataForEachRow.countOfOperatorRequested -
            dataForEachRow.countOfCheckout
        ) {
          count =
            dataForEachRow.countOfOperatorRequested -
            dataForEachRow.countOfCheckout;
          event.target.value = count;
        }
      }
      this.updateTransactionCountInfo({ index, count });
      this.dischargePermission.partialDischargePermissionItemsQueryDto[
        index
      ].partialDischargePermissionShelveInfoQuery.remainingCountForCheckout =
        count;
    },
    updateModelLocalStorage() {
      this.modelForLocalStorage = [];
      for (
        let index = 0;
        index < this.modelForLocalStorageReturn.length;
        index++
      ) {
        if (this.modelForLocalStorageReturn[index].serialsInfo.length) {
          for (
            let jj = 0;
            jj < this.modelForLocalStorageReturn[index].serialsInfo.length;
            jj++
          ) {
            if (
              !this.modelForLocalStorageReturn[index].serialsInfo[jj]
                .isshowWarrantyCard
            ) {
              this.modelForLocalStorageReturn[index].serialsInfo[jj] = {
                ...this.modelForLocalStorageReturn[index].serialsInfo[jj],
                isshowWarrantyCard: false,
              };
            }
            if (
              !this.modelForLocalStorageReturn[index].serialsInfo[jj]
                .isshowLabelPrint
            ) {
              this.modelForLocalStorageReturn[index].serialsInfo[jj] = {
                ...this.modelForLocalStorageReturn[index].serialsInfo[jj],
                isshowLabelPrint: false,
              };
            }
          }
        }
      }
      this.modelForLocalStorage = this.modelForLocalStorageReturn;
    },
    updateNewDataFromForEachRow(oldSerialsInfo, newSerialsInfo, oldIndex) {
      var finalSerialsInfo = [];
      var isOldSerial = false;
      for (let index = 0; index < newSerialsInfo.length; index++) {
        for (let ind = 0; ind < oldSerialsInfo.length; ind++) {
          if (oldSerialsInfo[ind] == newSerialsInfo[index]) {
            finalSerialsInfo.push(oldSerialsInfo[ind]);
            isOldSerial = true;
            break;
          }
        }
        if (!isOldSerial) {
          finalSerialsInfo.push(newSerialsInfo[index]);
        }
      }
      this.oldDataFromLocalStorage[oldIndex].serialsInfo = finalSerialsInfo;
    },
    onfinish(modelForLocalStorageReturn, type) {
      if (type != "notNew") {
        this.modelForLocalStorageReturn = modelForLocalStorageReturn;
        this.oldDataFromLocalStorage = JSON.parse(
          localStorage.getItem(
            "basket" + this.basketId + "store" + this.storeId
          )
        );
        localStorage.removeItem(
          "basket" + this.basketId + "store" + this.storeId
        );
        if (type == "forEachRow") {
          for (
            let index = 0;
            index < this.oldDataFromLocalStorage.length;
            index++
          ) {
            if (
              this.modelForLocalStorageReturn.itemCode ==
              this.oldDataFromLocalStorage[index].itemCode
            ) {
              this.updateNewDataFromForEachRow(
                this.oldDataFromLocalStorage[index].serialsInfo,
                this.modelForLocalStorageReturn.serialsInfo,
                index
              );
              this.modelForLocalStorageReturn = this.oldDataFromLocalStorage;
              break;
            }
          }
        }
        this.updateModelLocalStorage();
        localStorage.setItem(
          "basket" + this.basketId + "store" + this.storeId,
          JSON.stringify(this.modelForLocalStorage)
        );
        this.conversionDataFromLocalStorageToModelForShow();
      } else {
        this.getDataFromLocalStorage();
      }
      this.onShowAddSerialWithBarcodeReaderPopup = false;
      this.onShowAddSerialWithBarcodeReaderAccumulativePopup = false;
      this.showSerialPopup = false;
    },
    findMaxIndex() {
      for (let ii = 0; ii < this.modelForShow.length; ii++) {
        var serialsList = this.modelForShow[ii].serialsInfo;
        for (let i = 0; i < serialsList.length; i++) {
          if (serialsList[i].index > this.lastIndexRegistered) {
            this.lastIndexRegistered = serialsList[i].index;
          }
        }
      }
    },
    addSerial(itemCodeCurrent) {
      this.startProcessOfDischargePermissionForCheckout(
        this.modelForTime.dischargePermissionId
      ).then(() => {
        this.lastIndexRegistered = 0;
        this.findMaxIndex();
        this.itemCodeCurrent = itemCodeCurrent;
        this.oldDataFromLocalStorage = JSON.parse(
          localStorage.getItem(
            "basket" + this.basketId + "store" + this.storeId
          )
        );
        for (let index = 0; index < this.modelForShow.length; index++) {
          if (this.modelForShow[index].itemCode == itemCodeCurrent) {
            this.modelForInternalApi = {
              storeId: this.modelForShow[index].storeId,
              shelveId: this.modelForShow[index].shelveId,
              stockId: this.modelForShow[index].stockId,
            };
            break;
          }
        }
        for (
          let index = 0;
          index < this.oldDataFromLocalStorage.length;
          index++
        ) {
          if (this.oldDataFromLocalStorage[index].itemCode == itemCodeCurrent) {
            this.modelForShowCurrent = this.oldDataFromLocalStorage[index];
            break;
          }
        }
        this.showSerialPopup = true;
      });
    },
    createModelFinallyForApi() {
      this.modelForApi.inventoryTransactionItemCommands.forEach((elem) => {
        for (let index = 0; index < this.modelForShow.length; index++) {
          if (this.modelForShow[index].stockId == elem.stockId) {
            if (
              this.modelForShow[index].serialsInfo.length ||
              this.modelForShow[index].productType == "Measurable"
            ) {
              elem.serialsInfo = this.modelForShow[index].serialsInfo;
              this.inventoryTransactionItemCommandsFinal.push(elem);
            }
          }
        }
      });
      this.modelForApi.inventoryTransactionItemCommands =
        this.inventoryTransactionItemCommandsFinal;
    },
    checkEmptyRows() {
      this.listRowIndesxNotComplate = [];
      this.isemptyRequest = true;
      for (
        let index = 0;
        index < this.oldDataFromLocalStorage.length;
        index++
      ) {
        const productType = this.modelForShow.find(
          (item) =>
            item.itemCode == this.oldDataFromLocalStorage[index].itemCode
        ).productType;
        if (productType == "Serial") {
          if (this.oldDataFromLocalStorage[index].serialsInfo.length != 0) {
            this.isemptyRequest = false;
          }
        } else {
          this.isemptyRequest = false;
        }
      }
    },
    findRowsNotComplete() {
      for (
        let index = 0;
        index < this.oldDataFromLocalStorage.length;
        index++
      ) {
        const productType = this.modelForShow.find(
          (item) =>
            item.itemCode == this.oldDataFromLocalStorage[index].itemCode
        ).productType;
        if (productType == "Serial") {
          if (
            !(
              this.oldDataFromLocalStorage[index].serialsInfo.length ==
                this.oldDataFromLocalStorage[index].remainingCountForCheckout ||
              this.oldDataFromLocalStorage[index].remainingCountForCheckout == 0
            )
          ) {
            this.listRowIndesxNotComplate.push(index);
          }
        }
      }
    },
    createWrongTextForMessage() {
      this.wrongTextForMessage = "";
      if (this.listRowIndesxNotComplate.length > 1)
        this.wrongTextForMessage = "ردیف های ";
      else this.wrongTextForMessage = "ردیف ";
      for (
        let index = 0;
        index < this.listRowIndesxNotComplate.length;
        index++
      ) {
        this.wrongTextForMessage +=
          this.listRowIndesxNotComplate[index] + 1 + " , ";
      }
    },
    addSerialsForce() {
      this.createModelFinallyForApi();

      //todo: refactor these lines
      const payload = this.modelForApi;
      for (let item of payload.inventoryTransactionItemCommands) {
        const stockId = item.stockId;
        const productType = this.modelForShow.find(
          (item) => item.stockId == stockId
        ).productType;
        if (productType == "Measurable") {
          payload.inventoryTransactionItemCommands.find(
            (item) => item.stockId == stockId
          ).count = this.modelForShow.find(
            (item) => item.stockId == stockId
          ).remainingCountForCheckout;
        }
      }
      payload.inventoryTransactionItemCommands =
        payload.inventoryTransactionItemCommands.filter(
          (obj, index, self) =>
            index === self.findIndex((t) => t.stockId === obj.stockId)
        );
      this.createCheckOut(payload)
        .then(() => {
          localStorage.removeItem(
            "basket" + this.basketId + "store" + this.storeId
          );
          setTimeout(() => {
            this.$router.push(
              "/DischargePermissions/Details/" +
                4 +
                "/" +
                this.dischargePermission.id
            );
          }, 3000);
        })
        .catch(() => {
          this.disabled = false;
        });
    },
    async submitForm() {
      this.oldDataFromLocalStorage = JSON.parse(
        localStorage.getItem("basket" + this.basketId + "store" + this.storeId)
      );
      this.checkEmptyRows();
      if (!this.isemptyRequest) {
        this.findRowsNotComplete();
        if (this.listRowIndesxNotComplate.length == 0) {
          this.addSerialsForce();
        } else {
          this.createWrongTextForMessage();
          this.$swal({
            title:
              this.wrongTextForMessage +
              "تکمیل نشده است.آیا مایل به ثبت حواله خروج هستید؟",
            type: "warning",
            showCancelButton: true,
            confirmButtonColor: "#3085d6",
            cancelButtonColor: "#d33",
            confirmButtonText: "بلی",
            cancelButtonText: "خیر",
          }).then((result) => {
            if (result.value) {
              this.addSerialsForce();
            }
          });
        }
      } else {
        this.$swal({
          position: "center-center",
          type: "warning",
          text: "هیچ سریالی انتخاب نشده است.",
          showConfirmButton: false,
          timer: 2000,
        });
      }
    },
    handleFileUpload() {
      this.file = this.$refs.file.files[0];
      this.uploadedFileName = this.file.name;
      this.fileUploaded = true;
    },
    removeUploadFile() {
      this.file = "";
      this.$refs.file.files = this.emptyFileInRefs;
      this.uploadedFileName = "";
      this.fileUploaded = false;
    },
    uploadFile() {
      this.disabledBtn = true;
      let formData = new FormData();
      formData.append("file", this.file);
      this.importCheckOutTransactions(formData).then(() => {
        setTimeout(() => {
          this.$refs.grid.renderGrid();
        }, 3000);
      });
      setTimeout(() => {
        this.removeUploadFile();
        this.updateLoading = false;
        this.disabledBtn = false;
      }, 1000);
    },
    checkIsProcessing() {
      if (typeof this.isProcess != "boolean") {
        this.fetchSingle(this.dischargePermissionId).then((r) => {
          this.isProcess = r.isProcess;
        });
      }
    },
  },
};
</script>
